/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { OfferRejectionReason } from 'types/entities/specific/OfferRejectionReason'
import { RootState } from 'helpers/store'
import {
    resetRejectionReasonsCatalog,
    setRejectionReasonsCatalog,
    StoredRejectionReason,
} from 'store/crm/CrmReducer'
import { AppThunkDispatch } from 'helpers/store'

export type { StoredRejectionReason }

export const getDefaultRejectionReasons = (
    t: (key: string) => string
): StoredRejectionReason[] => [
    {
        id: 'different_provider',
        label: t('Decided on a different provider/venue'),
    },
    {
        id: 'budget_limit',
        label: t('Budget too low/price higher than expected'),
    },
    {
        id: 'distance',
        label: t('Travel/distance too far for the group'),
    },
    {
        id: 'not_suitable',
        label: t(
            'No suitable offer available from us (e.g., special opening, availability, group size, time slot)'
        ),
    },
    {
        id: 'internal_cancel',
        label: t('Event was internally canceled or postponed'),
    },
    {
        id: 'no_suitable_request',
        label: t(
            'No suitable event request (searched for something else, request withdrawn immediately)'
        ),
    },
    {
        id: 'other',
        label: t('Other reason'),
        requireComment: true,
    },
]

export const selectRejectionReasonsCatalog = (state: RootState) =>
    state.crmState.rejectionReasons

export const resolveRejectionReasons = (
    t: (key: string) => string,
    stored: StoredRejectionReason[] | null
): OfferRejectionReason[] => {
    if (stored && stored.length > 0) {
        return stored
    }

    return getDefaultRejectionReasons(t)
}

export const saveRejectionReasonsCatalog = (
    dispatch: AppThunkDispatch,
    reasons: StoredRejectionReason[]
) => {
    dispatch(setRejectionReasonsCatalog(reasons))
}

export const resetRejectionReasonsCatalogToDefaults = (
    dispatch: AppThunkDispatch
) => {
    dispatch(resetRejectionReasonsCatalog())
}
